
import pages from './pages'

import others from './others'

// Array of sections
export default [...pages,  ...others]
